export const defaults = {
  forgotPassword: "Forgot password",
  userMessage:
    "Enter your username and we will email you a link to reset your password.",
  enterUsername: "Please Enter Username",
  sendPassword: "Send reset password link",
  returnToLogin: "Return to login",
  emailMessage:
    "Instructions to reset your password have been sent to your email.",
  linkSent: "Link sent!",
  checkEmail: "Check your email for a reset password link.",
  errorMessage: "Invalid Username or Something went wrong",
};
